import { useState, useEffect, RefObject } from 'react';

interface ContainerSizeProps {
  width: number;
  height: number;
}

export const useContainerSize = (
  ref: RefObject<HTMLElement>,
): ContainerSizeProps => {
  const [size, setSize] = useState<ContainerSizeProps>({ width: 0, height: 0 });

  useEffect(() => {
    const updateSize = () => {
      if (ref.current) {
        const { clientWidth, clientHeight } = ref.current;
        setSize({ width: clientWidth, height: clientHeight });
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, [ref]);

  return size;
};
